module.exports = __webpack_public_path__ + "static/fonts/fa-light-300.07f8fc9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.woff2
// module id = iw1X
// module chunks = 12